import { FullScreenLoader } from '@components/Fillers/FullScreenLoader'
import Header from '@components/ScreenHeader'
import { Spacer } from '@components/Spacer'
import ClockTag from '@features/stories/components/ClockTag'
import { cdnUrlFromPath } from '@lib/utils/cdnUrlFromPath'
import { ValidId } from '@purposity/utils'
import * as Colors from '@themes/Colors'
import Fonts from '@themes/Fonts'
import * as React from 'react'
import { ScrollView, StyleSheet, Text, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { createParam } from 'solito'
import { SolitoImage } from 'solito/image'
import { useRouter } from 'solito/router'
import { useStory } from '../hooks/useStory'

type Params = {
  id: number
}

const { useParam } = createParam<Params>()

export function DetailScreen() {
  const router = useRouter()

  const [id] = useParam('id', {
    initial: 0,
    parse: (value) => ValidId.parse(value),
  })

  const story = useStory(id)

  if (story) {
    const { title, hero_image_path, body, published_date } = story

    const heroImageUrl = cdnUrlFromPath(hero_image_path!)

    const publishedDate = new Date(published_date!)

    return (
      <SafeAreaView style={styles.screenContainer}>
        <Header title="Stories" backAction={() => router.push('/stories')} />

        <StoryView
          heroImageUrl={heroImageUrl || ''}
          title={title}
          publishedDate={publishedDate}
          body={body}
        />
      </SafeAreaView>
    )
  } else {
    return (
      <View style={styles.screenContainer}>
        <FullScreenLoader />
      </View>
    )
  }
}

type StoryViewProps = {
  title: string
  heroImageUrl: string
  publishedDate: Date
  body: string
}

export function StoryView(props: StoryViewProps) {
  return (
    <ScrollView style={styles.content}>
      <View style={styles.imageContainer}>
        <SolitoImage
          src={props.heroImageUrl}
          contentFit="cover"
          style={styles.image}
          alt=""
          width={800}
          height={450}
        />
      </View>
      <View style={styles.body}>
        <Text style={styles.title}>{props.title}</Text>
        <Spacer height={8} noShrink />
        <ClockTag date={props.publishedDate} />
        <Spacer height={12} noShrink />

        <Text style={styles.descriptionText}>{props.body}</Text>
      </View>
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  screenContainer: {
    flex: 1,
    width: '100%',
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: Colors.borderGray,
  },
  content: {
    flex: 1,
    width: '100%',
    overflow: 'scroll',
  },
  imageContainer: {
    width: '100%',
    aspectRatio: 16 / 9,
    position: 'relative',
  },
  image: {
    width: '100%',
    height: '100%',
  },
  body: {
    flex: 1,
    paddingTop: 48,
    paddingBottom: 48 * 2,
    paddingHorizontal: 32,
  },
  title: {
    fontFamily: Fonts.type.bold,
    fontSize: 22,
    lineHeight: 28,
  },
  descriptionText: {
    color: Colors.descriptionGray,
    fontFamily: Fonts.type.regular,
    fontSize: 16,
    lineHeight: 22,
  },
})

export default DetailScreen
